/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as AuthedRouteImport } from './routes/_authed'
import { Route as AuthSigninRouteImport } from './routes/_auth/signin'
import { Route as AuthSignupRouteImport } from './routes/_auth/signup'
import { Route as AuthedIndexRouteImport } from './routes/_authed/index'
import { Route as AuthedNotesRouteImport } from './routes/_authed/notes'
import { Route as AuthedSettingsRouteImport } from './routes/_authed/settings'
import { Route as AuthedAskIndexRouteImport } from './routes/_authed/ask.index'
import { Route as AuthedAskThreadIdRouteImport } from './routes/_authed/ask.$threadId'
import { Route as AuthedBillingIndexRouteImport } from './routes/_authed/billing.index'
import { Route as AuthedBillingSuccessRouteImport } from './routes/_authed/billing.success'
import { Route as AuthedNIdRouteImport } from './routes/_authed/n.$id'

const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedRoute = AuthedRouteImport.update({
  id: '/_authed',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthSigninRoute = AuthSigninRouteImport.update({
  id: '/signin',
  path: '/signin',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSignupRoute = AuthSignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => AuthRoute,
} as any)
const AuthedIndexRoute = AuthedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedNotesRoute = AuthedNotesRouteImport.update({
  id: '/notes',
  path: '/notes',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedSettingsRoute = AuthedSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAskIndexRoute = AuthedAskIndexRouteImport.update({
  id: '/ask/',
  path: '/ask/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAskThreadIdRoute = AuthedAskThreadIdRouteImport.update({
  id: '/ask/$threadId',
  path: '/ask/$threadId',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedBillingIndexRoute = AuthedBillingIndexRouteImport.update({
  id: '/billing/',
  path: '/billing/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedBillingSuccessRoute = AuthedBillingSuccessRouteImport.update({
  id: '/billing/success',
  path: '/billing/success',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedNIdRoute = AuthedNIdRouteImport.update({
  id: '/n/$id',
  path: '/n/$id',
  getParentRoute: () => AuthedRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthedIndexRoute
  '/signin': typeof AuthSigninRoute
  '/signup': typeof AuthSignupRoute
  '/notes': typeof AuthedNotesRoute
  '/settings': typeof AuthedSettingsRoute
  '/ask/$threadId': typeof AuthedAskThreadIdRoute
  '/billing/success': typeof AuthedBillingSuccessRoute
  '/n/$id': typeof AuthedNIdRoute
  '/ask/': typeof AuthedAskIndexRoute
  '/billing/': typeof AuthedBillingIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof AuthedIndexRoute
  '/signin': typeof AuthSigninRoute
  '/signup': typeof AuthSignupRoute
  '/notes': typeof AuthedNotesRoute
  '/settings': typeof AuthedSettingsRoute
  '/ask/$threadId': typeof AuthedAskThreadIdRoute
  '/billing/success': typeof AuthedBillingSuccessRoute
  '/n/$id': typeof AuthedNIdRoute
  '/ask': typeof AuthedAskIndexRoute
  '/billing': typeof AuthedBillingIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_auth': typeof AuthRouteWithChildren
  '/_authed': typeof AuthedRouteWithChildren
  '/_auth/signin': typeof AuthSigninRoute
  '/_auth/signup': typeof AuthSignupRoute
  '/_authed/notes': typeof AuthedNotesRoute
  '/_authed/settings': typeof AuthedSettingsRoute
  '/_authed/': typeof AuthedIndexRoute
  '/_authed/ask/$threadId': typeof AuthedAskThreadIdRoute
  '/_authed/billing/success': typeof AuthedBillingSuccessRoute
  '/_authed/n/$id': typeof AuthedNIdRoute
  '/_authed/ask/': typeof AuthedAskIndexRoute
  '/_authed/billing/': typeof AuthedBillingIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/signin'
    | '/signup'
    | '/notes'
    | '/settings'
    | '/ask/$threadId'
    | '/billing/success'
    | '/n/$id'
    | '/ask/'
    | '/billing/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/signin'
    | '/signup'
    | '/notes'
    | '/settings'
    | '/ask/$threadId'
    | '/billing/success'
    | '/n/$id'
    | '/ask'
    | '/billing'
  id:
    | '__root__'
    | '/_auth'
    | '/_authed'
    | '/_auth/signin'
    | '/_auth/signup'
    | '/_authed/notes'
    | '/_authed/settings'
    | '/_authed/'
    | '/_authed/ask/$threadId'
    | '/_authed/billing/success'
    | '/_authed/n/$id'
    | '/_authed/ask/'
    | '/_authed/billing/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthRoute: typeof AuthRouteWithChildren
  AuthedRoute: typeof AuthedRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed': {
      id: '/_authed'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/signin': {
      id: '/_auth/signin'
      path: '/signin'
      fullPath: '/signin'
      preLoaderRoute: typeof AuthSigninRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/signup': {
      id: '/_auth/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof AuthSignupRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_authed/': {
      id: '/_authed/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthedIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/notes': {
      id: '/_authed/notes'
      path: '/notes'
      fullPath: '/notes'
      preLoaderRoute: typeof AuthedNotesRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/settings': {
      id: '/_authed/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthedSettingsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/ask/': {
      id: '/_authed/ask/'
      path: '/ask'
      fullPath: '/ask/'
      preLoaderRoute: typeof AuthedAskIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/ask/$threadId': {
      id: '/_authed/ask/$threadId'
      path: '/ask/$threadId'
      fullPath: '/ask/$threadId'
      preLoaderRoute: typeof AuthedAskThreadIdRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/billing/': {
      id: '/_authed/billing/'
      path: '/billing'
      fullPath: '/billing/'
      preLoaderRoute: typeof AuthedBillingIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/billing/success': {
      id: '/_authed/billing/success'
      path: '/billing/success'
      fullPath: '/billing/success'
      preLoaderRoute: typeof AuthedBillingSuccessRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/n/$id': {
      id: '/_authed/n/$id'
      path: '/n/$id'
      fullPath: '/n/$id'
      preLoaderRoute: typeof AuthedNIdRouteImport
      parentRoute: typeof AuthedRoute
    }
  }
}

interface AuthRouteChildren {
  AuthSigninRoute: typeof AuthSigninRoute
  AuthSignupRoute: typeof AuthSignupRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthSigninRoute: AuthSigninRoute,
  AuthSignupRoute: AuthSignupRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

interface AuthedRouteChildren {
  AuthedNotesRoute: typeof AuthedNotesRoute
  AuthedSettingsRoute: typeof AuthedSettingsRoute
  AuthedIndexRoute: typeof AuthedIndexRoute
  AuthedAskThreadIdRoute: typeof AuthedAskThreadIdRoute
  AuthedBillingSuccessRoute: typeof AuthedBillingSuccessRoute
  AuthedNIdRoute: typeof AuthedNIdRoute
  AuthedAskIndexRoute: typeof AuthedAskIndexRoute
  AuthedBillingIndexRoute: typeof AuthedBillingIndexRoute
}

const AuthedRouteChildren: AuthedRouteChildren = {
  AuthedNotesRoute: AuthedNotesRoute,
  AuthedSettingsRoute: AuthedSettingsRoute,
  AuthedIndexRoute: AuthedIndexRoute,
  AuthedAskThreadIdRoute: AuthedAskThreadIdRoute,
  AuthedBillingSuccessRoute: AuthedBillingSuccessRoute,
  AuthedNIdRoute: AuthedNIdRoute,
  AuthedAskIndexRoute: AuthedAskIndexRoute,
  AuthedBillingIndexRoute: AuthedBillingIndexRoute,
}

const AuthedRouteWithChildren =
  AuthedRoute._addFileChildren(AuthedRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthRoute: AuthRouteWithChildren,
  AuthedRoute: AuthedRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
